import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { planTotal } from "./StorageBits";

const CONFIRM = "Trim storage now? Drops raw source text on rewritten articles, strips purged tombstones, deletes stuck rewrites, stale never-published drafts and old logs, and moves sites to the 14/14-day window. This cannot be undone.";
const CONFIRM_DRAFTS = "Delete every never-published article older than 14 days (pending, ready, rejected, archived-from-ready)? They never had a public URL, so nothing needs a 410. This cannot be undone.";

/** Storage overview + "Trim now" / "Purge stale drafts" actions. */
export function useStorage() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [draftsResult, setDraftsResult] = useState(null);
  const [err, setErr] = useState("");

  const load = useCallback(async () => {
    try { const r = await api.get("/admin/storage"); setData(r.data); }
    catch (e) { setErr(e.response?.data?.detail || e.message); }
  }, []);
  useEffect(() => { load(); }, [load]);

  async function run(fn) {
    setBusy(true); setErr("");
    try { await fn(); await load(); }
    catch (e) { setErr(e.response?.data?.detail || e.message); }
    finally { setBusy(false); }
  }

  function trim() {
    if (!window.confirm(CONFIRM)) return;
    setResult(null);
    run(async () => { const r = await api.post("/admin/storage/trim", { dry_run: false }); setResult(r.data); });
  }

  function purgeDrafts() {
    if (!window.confirm(CONFIRM_DRAFTS)) return;
    setDraftsResult(null);
    run(async () => { const r = await api.post("/admin/storage/purge-drafts", { dry_run: false }); setDraftsResult(r.data); });
  }

  return { data, busy, result, draftsResult, err, load, trim, purgeDrafts, pending: planTotal(data?.plan) };
}
